import { StateCreator } from 'zustand';

export interface OASISManagerFilters {
  activeTab: 'incomplete' | 'ready_to_export' | 'exported';
  patientSearch: string;
  clinicId: string | null;
}

export interface OASISManagerSlice {
  oasisManagerFilters: OASISManagerFilters;
  setOASISManagerFilters: (filters: Partial<OASISManagerFilters>) => void;
}

const DEFAULT_OASIS_MANAGER_FILTERS: OASISManagerFilters = {
  activeTab: 'incomplete',
  patientSearch: '',
  clinicId: null,
};

export const oasisManagerSlice: StateCreator<OASISManagerSlice> = set => ({
  oasisManagerFilters: DEFAULT_OASIS_MANAGER_FILTERS,
  setOASISManagerFilters: (filters: Partial<OASISManagerFilters>) =>
    set(state => ({
      oasisManagerFilters: { ...state.oasisManagerFilters, ...filters },
    })),
});
